import React, { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { generateOTP, verifyOTP } from '../../helper/helper';
import { useLocation, useNavigate } from 'react-router-dom';
import './Recovery.scss';
// import logo from '../../assets/logo.png';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import RecoverySideBar from '../ui/SideBanner';

const Recovery = () => {
  const username = localStorage.getItem('username');
  const [OTP, setOTP] = useState();
  const [otpGenerated, setOtpGenerated] = useState(false); // Track if OTP is generated
  const [timer, setTimer] = useState(60);
  const navigate = useNavigate(); 
  const location = useLocation();
  const isFirstLogin = location.state?.firstTimeLogin;;

  useEffect(() => {
    if (username) {
      generateOTP(username,isFirstLogin)
        .then((OTP) => {
          if (OTP) {
            toast.success('OTP has been sent to your email!');
            setOtpGenerated(true); // Set OTP generated to true
            startTimer(); // Start the timer
          }
        })
        .catch(() => {
          toast.error('Problem while generating OTP!');
        });
    }
  }, [username,isFirstLogin]);

  function startTimer() {
    const countdown = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(countdown);
          setOtpGenerated(false); // Allow OTP resend after timer ends
          return 60; // Reset timer
        }
        return prev - 1;
      });
    }, 1000);
  }

  async function onSubmit(e) {
    e.preventDefault();
    try {
      let { status } = await verifyOTP({ username, code: OTP });
      if (status === 201) {
        toast.success('Verified Successfully!');
        return navigate('/reset');
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.error || 'Wrong OTP! Check email again!';
      toast.error(errorMessage, {
        id: 'wrongOTP',
        duration: 3000,
        style: {
          border: '2px solid red',
          fontSize: '16px',
          fontWeight: '480',
          padding: '6px',
          borderRadius: '10px',
        },
      });
    }
  }

  // handler of resend OTP
  function resendOTP() {
    if (!otpGenerated) {
      let sentPromise = generateOTP(username ,isFirstLogin);

      toast.promise(sentPromise, {
        loading: 'Sending...',
        success: <b>OTP has been sent to your email!</b>,
        error: <b>Could not send it!</b>,
      });

      sentPromise
        .then((OTP) => {
          setOtpGenerated(true); // Set OTP generated to true
          startTimer(); // Restart the timer
        })
        .catch(() => {
          toast.error('Problem while generating OTP!');
        });
    }
  }

  return (
    <div className="recovery_container">
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{ duration: 3000 }}
        gutter={4}
      />
      <RecoverySideBar/>
      {/* <div className="left">
        <div className="overlay">
          <div className="bot">
            <div className="logo">
              <img src={logo} alt="logo" />
              <div className="footer">
                <p>Copyright © {new Date().getFullYear()} - Vyadom Group. All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <form className="right" onSubmit={onSubmit}>
        <div className="main">
          <h3 className="heading">Forgot Password</h3>
          <span className="middle-span">Enter 6 digit OTP code sent to your email address.</span>
          <input
            id="otp"
            type="text"
            className="middle-input"
            placeholder="OTP Code"
            onChange={(e) => setOTP(e.target.value)}
          />
            <div className="timer" style={{ opacity: otpGenerated ? 1 : 0 }}>
              <span>Time remaining: <span className='countdown'>{timer}</span> seconds</span>
            </div>

          <div className="submitbutton">
            <button type="submit">Verify And Continue</button>
          </div>

          <div className="bottom">
            <span className="bottom-span">
              Didn't Receive an OTP? &nbsp;&nbsp;
              <Button
                onClick={resendOTP}
                size="small"
                variant="outlined"
                color="primary"
                endIcon={<SendIcon />}
                disableElevation
                disabled={otpGenerated}
              >
                Resend Code
              </Button>
            </span>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Recovery;
